const config = require('@/../vue.config');
export function hasBtn(btnName){
    var user = JSON.parse(sessionStorage.getItem('user'))||{};
    let btn = user.permissionList||[];
    if (btn.length==0){
        return false
    }else {
        return btn.indexOf(btnName) > -1;
    }
}
export function removeByIndex(arr,index) {
    for(var i=0; i<arr.length; i++) {
        if(i == index) {
            arr.splice(i, 1);
            break;
        }
    }
}
export function router_url(url,query) {
    var date = new Date().getTime();
    var query_obj={
        t:date
    };
    if (query) {
        query['t']=date;
    }else{
        query=query_obj
    }
    this.$router.push({
        path: url,
        query:query
    });
}
export function getTime(/** timestamp=0 **/) {  
    var ts = arguments[0] || 0;  
    var t,y,m,d,h,i,s;  
    t = ts ? new Date(ts*1000) : new Date();
    // t = getDate(parseInt(ts*1000));
    y = t.getFullYear();    //年
    m = t.getMonth()+1;    // 月
    d = t.getDate();    //日
    h = t.getHours();    //时
    i = t.getMinutes();    //分
    s = t.getSeconds();   //秒
    // 可根据需要在这里定义时间格式  
    if (arguments[1]=='y') {
        return y+'-'+(m<10?'0'+m:m)+'-'+(d<10?'0'+d:d);
    }else if(arguments[1]=='m'){
        return (m<10?'0'+m:m)+'-'+(d<10?'0'+d:d);
    }else if(arguments[1]=='d'){
        return (d<10?'0'+d:d); 
    }else if(arguments[1]=='yyyy'){
        return y
    }else{
        return y+'-'+(m<10?'0'+m:m)+'-'+(d<10?'0'+d:d)+' '+(h<10?'0'+h:h)+':'+(i<10?'0'+i:i)+':'+(s<10?'0'+s:s);  
    }
}

// 是否是手机
export function isMobile() {
    var userAgentInfo = navigator.userAgent;
    var mobileAgents = [ "Android", "iPhone", "SymbianOS", "Windows Phone", "iPad","iPod"];
    var mobile_flag = false;
    //根据userAgent判断是否是手机
    for (var v = 0; v < mobileAgents.length; v++) {
      if (userAgentInfo.indexOf(mobileAgents[v]) > 0) {
          mobile_flag = true;
          break;
      }
    }
    var screen_width = window.screen.width;
    var screen_height = window.screen.height;   
    //根据屏幕分辨率判断是否是手机
    if(screen_width < 500 && screen_height < 800){
       mobile_flag = true;
    }
    return mobile_flag;
}


/**
 * 获取屏幕高度
 * @param {number} height 要减去的高度
 * @return {number}
 */
export function screenHeight(height = 0) {
    // 20  20  50 50 60
    var deduct=180 + 50;
    var defaultHeight = 880
    var winHeight;
    if (window.innerHeight) {
        winHeight = window.innerHeight;
    } else if ((document.body) && (document.body.clientHeight)) {
        winHeight = document.body.clientHeight;
    }
    if (document.documentElement && document.documentElement.clientHeight) {
        winHeight = document.documentElement.clientHeight;
    }
    if (winHeight) {
        return winHeight - height - deduct
    } else {
        return defaultHeight - height - deduct
    }
}
const aRouter = []
export const formatRoutes = (aMenu) => {
    aMenu.forEach(oMenu => {
        const {path, title, icon, children,component,status } = oMenu
        if(children&&children.length>0){
            formatRoutes(children);
        }
        if(path&&status){
            const oRouter = {
                path:path,
                name:title+path,
                icon: icon,
                component:loadView(component),
            }
            aRouter.push(oRouter)
        }
    })
    return aRouter
}
export const loadView = (view) => {
  return resolve => require([`@/views/${view}`], resolve).catch(err => {
  })
}

export function transListDataToTreeData(list, root){
    const arr = []
    // 1.遍历
    list.forEach((item) => {
        // 2.首次传入空字符串  判断list的pid是否为空 如果为空就是一级节点
        if (item.pid === root) {
            // 找到之后就要去找item下面有没有子节点  以 item.id 作为 父 id, 接着往下找
            const children = transListDataToTreeData(list, item.id)
            if (children.length > 0) {
                // 如果children的长度大于0,说明找到了子节点
                item.children = children
            }
            // 将item项, 追加到arr数组中
            var obj={
                ...item,
                label:item.name||item.title
            }
            arr.push(obj)
        }
    })
    return arr
}
export function convertToTreeData(list, id = null, linkId = 'id', parentId = 'pid') {
    const map = new Map();
    list.forEach(item => {
        item.label=item.name||item.title;
        map.set(item[linkId], item);
    });
    const treeData = [];
    list.forEach(item => {
        const parent = map.get(item[parentId]);
        if (parent) {
            if(!parent.children){
                parent['children'] = [item];
            }else{
                parent.children.push(item);
            }
        } else {
            treeData.push(item);
        }
    });
    return treeData;
}
export function array_object(list){
    var arr={};
    for (var i = 0; i < list.length; i++) {
        arr[list[i].code] = list[i].name;
    }
    return arr
}


// WEBPACK FOOTER //
// ./src/utils/index.js